import { apiInstance } from 'api/utils';
// TODO: remove test1 from url

const contributionsApi = {
  getContributions: ({ portfolio }: { portfolio: any }) => {
    return apiInstance.request({
      method: 'GET',
      url: `/cases/${portfolio}/contributions/`
    });
  },
  getContributionsSummary: ({ portfolio }: { portfolio: any }) => {
    return apiInstance.request({
      method: 'GET',
      url: `/cases/${portfolio}/contributions/summary/`
    });
  },
  allocateMoney: ({
    portfolio,
    contributionId,
    policyId,
    allocateData
  }: {
    portfolio: any;
    contributionId: number;
    policyId: number;
    allocateData: {
      amount: string;
    };
  }) => {
    return apiInstance.request({
      method: 'POST',
      url: `/cases/${portfolio}/policies/${policyId}/add_contribution/${contributionId}/`,
      data: allocateData
    });
  },
  createContribution: ({
    portfolio,
    newContribution
  }: {
    portfolio: any;
    newContribution: {
      owner: {
        id: number;
      };
      amount: string;
      source: number;
      frequency: number;
    };
  }) => {
    return apiInstance.request({
      method: 'POST',
      url: `/cases/${portfolio}/contributions/`,
      data: newContribution
    });
  }
};

export default {
  ...contributionsApi
};
